import React, { useRef, useState, useEffect, useCallback } from "react";
import "./VolumeBar.css"

function clamp(v, a = 0, b = 1) {
  return Math.max(a, Math.min(b, v));
}

export default function VolumeBar({ value, onChange }) {
  const [isDragging, setIsDragging] = useState(false);
  const [previewValue, setPreviewValue] = useState(null);
  const barRef = useRef(null);

  const getPercentFromEvent = (e) => {
    const rect = barRef.current.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const x = clientX - rect.left;
    return clamp(x / rect.width, 0, 1);
  };

  const handleStart = (e) => {
    e.preventDefault();
    setIsDragging(true);
    const percent = getPercentFromEvent(e);
    setPreviewValue(percent);
    onChange?.(percent);
  };

  const handleMove = useCallback(
    (e) => {
      if (!isDragging) return;
      const percent = getPercentFromEvent(e);
      setPreviewValue(percent);
      onChange?.(percent);
    },
    [isDragging, onChange]
  );

  const handleEnd = useCallback(() => {
    if (!isDragging) return;
    setIsDragging(false);
    setPreviewValue(null);
  }, [isDragging]);

  useEffect(() => {
    document.addEventListener("mousemove", handleMove);
    document.addEventListener("mouseup", handleEnd);
    document.addEventListener("touchmove", handleMove);
    document.addEventListener("touchend", handleEnd);

    return () => {
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("mouseup", handleEnd);
      document.removeEventListener("touchmove", handleMove);
      document.removeEventListener("touchend", handleEnd);
    };
  }, [handleMove, handleEnd]);

  const effectiveValue = isDragging ? previewValue : value;

  return (
    <div
      ref={barRef}
      className="d-volume-bar"
      onMouseDown={handleStart}
      onTouchStart={handleStart}
    >
      <div className="d-volume-laceholder"></div>
      <div className="d-volume-filled" style={{ width: `${effectiveValue * 100}%` }} />
    </div>
  );
}
